import querystring from 'querystring'

import React from 'react'
import PropTypes from 'prop-types'

import Font from '@cred/react-font'
import { ResizedImage } from '@cred/react-resized-image'
import { creditCard as spCreditCardContext } from '@cred/react-analytics/contexts'

import Link from 'components/link'
import CtaButton from 'components/cta-button'

import BottomDetails from './bottom-details'
import styles from './styles.module.scss'

const getCategorySlug = (categoryObject) =>
  categoryObject ? categoryObject.slug : 'unknown-category'
const getApplyNowLink = (slug, utms, uuid) =>
  `/credit-cards/apply-now/link-card/${slug}?${querystring.encode(utms)}&redirection_uuid=${uuid}`

const CardTile = ({
  slug,
  image,
  name,
  issuerPublicName,
  ratesAndFeesUrl,
  miniMarketplaceFeaturedCategory,
  analyticsContexts,
  utms,
  uuid,
  ...rest
}) => {
  const categorySlug = getCategorySlug(miniMarketplaceFeaturedCategory)

  return (
    <div className={styles.cardTile}>
      <section className={styles.topSection}>
        <div className={styles.cardAndCtaWrapper}>
          <ResizedImage
            className={styles.cardImage}
            src={image}
            alt={`${name} logo`}
            width={155}
            height={100}
          />
          <div className={styles.ctaAndTextWrapper}>
            <CtaButton
              className={styles.ctaButton}
              small
              blank
              analyticsContexts={[
                ...analyticsContexts,
                spCreditCardContext.analytics({
                  redirectUUID: uuid,
                  issuer: issuerPublicName,
                  cardName: name,
                  category: slug,
                }),
              ]}
              href={getApplyNowLink(slug, utms, uuid)}
            >
              Apply Now
            </CtaButton>
            <Font
              element="p"
              type="disclaimer"
              weight="regular"
              color="lighter"
              className={styles.ctaSubtext}
            >
              on {issuerPublicName}'s website
            </Font>
          </div>
        </div>
        <Font
          element="h3"
          type="bodySmall"
          weight="bold"
          color="neutral"
          className={styles.titleText}
        >
          {name}
          {!!ratesAndFeesUrl && (
            <Link blank href={ratesAndFeesUrl} className={styles.ratesAndFeesLink}>
              Rates and fees
            </Link>
          )}
        </Font>
      </section>
      <BottomDetails featuredCategorySlug={categorySlug} {...rest} />
    </div>
  )
}

CardTile.propTypes = {
  slug: PropTypes.string,
  image: PropTypes.string,
  name: PropTypes.string,
  issuerPublicName: PropTypes.string,
  ratesAndFeesUrl: PropTypes.string,
  miniMarketplaceFeaturedCategory: PropTypes.object,
  analyticsContexts: PropTypes.array,
  utms: PropTypes.object,
  uuid: PropTypes.string,
}

export default CardTile
